<template>
<div class="cnt-slider">
    <div class="lst-slider">
        <slick
            class="slider-row slick"
            ref="slick_incomes"
            :options="slickOptions"
        >
            <li v-for="item in summarys" :key="item.currency_id">
                <div class="box-news">
                    <div class="box-heading">
                        <div class="income-title">{{$t('summary.local_income')}}</div>
                        <div class="unit-date">{{ utils.getCurrencyName(item.currency_id) }}</div>
                    </div>
                    <table class="table-income">
                        <thead>
                            <td class="td-title">{{$t('summary.label.service')}}</td>
                            <td>{{$t('summary.label.deposit_income')}}</td>
                            <td>{{$t('summary.label.receipt')}}</td>
                            <td>{{$t('summary.label.payment')}}</td>
                            <td>{{$t('summary.label.unpaid')}}</td>
                            <td>{{$t('summary.label.income')}}</td>
                        </thead>
                        <tr v-if="'optional' in item.local_incomes">
                            <!-- <td class="td-title">{{$t('summary.label.optional')}}</td> -->
                            <td class="td-title">OP</td>
                            <td>{{ formatPrice(item.local_incomes.optional.total, item.currency_id) }}</td>
                            <td>{{ formatPrice(item.local_incomes.optional.receipt, item.currency_id) }}</td>
                            <td>{{ formatPrice(item.local_incomes.optional.payment, item.currency_id) }}</td>
                            <td>{{ formatPrice(item.local_incomes.optional.unpaid, item.currency_id) }}</td>
                            <td>{{ formatPrice(item.local_incomes.optional.income, item.currency_id) }}</td>
                        </tr>
                        <tr v-if="!isDomestic && 'mediation' in item.local_incomes">
                            <!-- <td class="td-title">{{$t('summary.label.mediation')}}</td> -->
                            <td class="td-title">斡旋</td>
                            <td>{{ formatPrice(item.local_incomes.mediation.total, item.currency_id) }}</td>
                            <td>-</td><td>-</td><td>-</td><td>-</td>
                        </tr>
                        <tr v-if="!isDomestic && 'gift' in item.local_incomes">
                            <!-- <td class="td-title">{{$t('summary.label.gift')}}</td> -->
                            <td class="td-title">土産</td>
                            <td>{{ formatPrice(item.local_incomes.gift.total, item.currency_id)}}</td>
                            <td>-</td><td>-</td><td>-</td><td>-</td>
                        </tr>
                        <tr v-if="isDomestic && 'mediationAndGift' in item.local_incomes">
                            <td class="td-title">{{$t('summary.label.mediationAndGift')}}</td>
                            <td>{{ formatPrice(item.local_incomes.mediationAndGift.total, item.currency_id) }}</td>
                            <td>-</td><td>-</td><td>-</td><td>-</td>
                        </tr>
                        <tr>
                            <td class="td-title">{{$t('summary.label.balance')}}</td>
                            <td>{{ formatPrice(item.local_incomes.total, item.currency_id) }}</td>
                            <td colspan="4"></td>
                        </tr>
                    </table>
                    <div v-if="isDomestic" class="list-cnt-item-diastamp">
                        <div class="cnt-item">
                            <div class="cnt-item-ttl">{{$t('summary.label.diastamp')}}</div>
                            <div class="cnt-item-num">
                                {{item.local_incomes.diastamps != null ? item.local_incomes.diastamps : 0 }}{{$t('voucher.general.sheet')}}
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        </slick>
    </div>
</div>
</template>
<script>
import Slick from "vue-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Constants } from "@/helpers/constants";
import Utils from "@/helpers/utils";

export default {
    name: "SpIncomeSummary",
    props: {
        summarys: {},
        slickOptions: {},
        tourInfo: {}
    },
    components: {
        Slick,
    },
    data() {
        const tourType = this.tourInfo.tour_type;
        return {
            utils: Utils,
            isDomestic: tourType == Constants.TourType.domestic.id,
        };
    },
    methods: {
        formatPrice(value, currencyId) {
            if (Utils.isEmptyStr(value)) {
                return "";
            }

            if (value == 0) {
                return "-"
            } else {
                return Utils.formatPrice(value, currencyId)
            }
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/views/components/common/Summary/IncomeSummary.vue